<form #formLogin="ngForm" name="formLogin" (submit)="handleLogin(formLogin.value, $event)" novalidate>
  <h3 class="page__heading text-dark-blue margin-bottom-24">
    {{ appCopy.panelHeader["title" + selectedLanguage] }}
  </h3>

  <div class="panel">
    <div class="panel__header">{{ appCopy.panelHeader["description" + selectedLanguage] }}</div>
    <div class="panel__body">
      <div class="section">
        <p class="text-muted text-dark-blue">{{ appCopy.panelHeader["heading" + selectedLanguage] }}</p>
      </div>
      <div class="section section__colored">
        <div class="form-group margin-bottom-16">
          <input class="form-control" [ngClass]="{ 'has-error': username.invalid && username.dirty }" id="Username"
            name="Username" type="email" #username="ngModel" [ngModel]="userEmail" [pattern]="emailPattern" ngModel
            required appCheckEmpty placeholder="{{
              appCopy.panelHeader['emailPlaceholder' + selectedLanguage]
            }}" readonly/>
          <i class="icon control-validation-state"></i>

          <p class="help-block text-danger" *ngIf="username?.errors?.pattern">
            {{ appCopy.panelHeader["validEmail" + selectedLanguage] }}
          </p>
          <p class="help-block text-danger" *ngIf="
              username.invalid && username.dirty && !username?.errors?.pattern
            ">
            {{ appCopy.panelHeader["warningEmail" + selectedLanguage] }}
          </p>
        </div>

        <div class="form-group">
          <div class="passwordIcon">
            <input class="form-control" [ngClass]="{ 'has-error': password.invalid && password.dirty }" id="Password"
            name="Password" [type]="showPassword ? 'text' : 'password'" #password="ngModel" ngModel alert-caps-lock required appCheckEmpty
            placeholder="{{
              appCopy.panelHeader['passwordPlaceholder' + selectedLanguage]
            }}" />
            <div class="btntoggle" (click)="togglePasswordVisibility()">
              <ng-container *ngIf="showPassword; else showText">
                <i class="icon-eye-blocked"></i>
              </ng-container>
              <ng-template #showText>
                <i class="icon-eye"></i>
              </ng-template>
            </div>
          </div>


          <p class="help-block text-danger" *ngIf="password.invalid && password.dirty">
            {{ appCopy.panelHeader["warningEnterPassword" + selectedLanguage] }}
          </p>
        </div>
      </div>

      <div class="section section__actions">
        <div class="flex flex--space-between margin-bottom-16 width-100">
          <div class="checkbox checkbox--default checkbox--small">
            <input type="checkbox" name="rememberMe" id="rememberMe" #rememberme="ngModel" [(ngModel)]="rememberMe" [checked]="true" />
            <label for="rememberMe" class="text-dark-blue">{{
              appCopy.panelHeader["rememberMe" + selectedLanguage]
              }}</label>
          </div>
          <a class="link" href="javascript:void(0)" *ngIf="parentRoute !== 'payment'" (click)="goToForgotPassword()">{{
            appCopy.panelHeader["btnForgot" + selectedLanguage] }}</a>
        </div>

        <div class="flex flex--justify-content-center text-center">
          <button type="submit" class="btn btn-purple btn-lg" [disabled]="formLogin.invalid">
            <div class="loader-container-btn" *ngIf="showLoader">
              <div class="loader loader--white">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" />
                </svg>
              </div>
            </div>
            {{ appCopy.panelHeader["btnLogin" + selectedLanguage] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<app-notifications></app-notifications>
